import type {
  HTMLAttributes,
  PropsWithChildren,
  ReactElement
} from 'react';

export const Linkifier = ({
  description,
  ...props
}: Linkifier.Props): ReactElement => {

    const linkify = (text: string): (JSX.Element | string)[]=>{

        const urlRegex = /\b((?:https?:\/\/|www\.)?[\d.a-z-]+\.[a-z]{2,}(?:\S*)?)\b/gi;


        return text.split(urlRegex).map((part, i) => {

            if(urlRegex.test(part)){
                let url = part;

                if (!/^https?:\/\//i.test(url)) {
                    url = `https://${url}`;

                    console.log({url});
                }

                return (
                    <a key={i} href={url} target="_blank" rel="noopener noreferrer">
                        {part}
                    </a>
                );
            }

            return part;
        });
    };

  return (
    <p {...props}>
      {linkify(description)}
    </p>
  );
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace Linkifier {
  export type Props = PropsWithChildren<HTMLAttributes<HTMLElement> & { description: string }>;
}
